export const enum MyAccountHeaderViewStoreEvent {
  filterSavedProperties = 'filterSavedProperties',
  sortSavedProperties = 'sortSavedProperties',
  deleteAllSavedProperties = 'deleteAllSavedProperties',
}
